import { Grid, TextField, InputAdornment } from "@mui/material";
import { forwardRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { useParams } from "react-router";
import { NumericFormat } from "react-number-format";
import {
  JClearance,
  setJTransactionDialog,
} from "../../../../../app/slices/jomla/clearanceSlice";
import { HiOutlineBanknotes, HiOutlineDocumentPlus } from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../../../components/FormDialog";

const JTransactionForm = () => {
  const { user_id } = useParams();
  const dispatch = useDispatch();

  const [reload, setReload] = useState(false);

  const _JTransaction = useSelector((state) => state.jClearance.jtransaction);
  const searchBody = useSelector((state) => state.jClearance.searchBody);

  const { control, handleSubmit } = useForm({
    defaultValues: _JTransaction.form,
  });

  const onSubmit = (data) => {
    data.user_id = user_id;
    dispatch(JClearance.addJTransaction(data, searchBody)).then((x) => {
      setReload(!reload);
    });
  };

  const handleDialog = () => {
    dispatch(setJTransactionDialog());
  };

  const NumericFormatCustom = forwardRef(function NumericFormatCustom(
    props,
    ref
  ) {
    const { onChange, ...other } = props;

    return (
      <NumericFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: parseInt(values.value) || 0,
            },
          });
        }}
        thousandSeparator
        valueIsNumericString
      />
    );
  });
  return (
    <FormDialog
      open={_JTransaction.dialog}
      onClose={handleDialog}
      maxWidth={"md"}
      icon={<HiOutlineDocumentPlus />}
      title="اضافة حركة مالية"
      subtitle="أدخل معلومات الحركة المالية لإضافتها"
      onSubmit={handleSubmit(onSubmit)}
      saveText="اضافة"
    >
      <SectionCard icon={<HiOutlineBanknotes />} title="معلومات الحركة">
        <Grid item xs={12} sm={6}>
          <Controller
            name="j_order_number"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="رقم الطلب"
                fullWidth
                {...field}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="amount"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="المبلغ"
                fullWidth
                {...field}
                InputProps={{
                  inputComponent: NumericFormatCustom,
                  startAdornment: (
                    <InputAdornment position="start">IQD</InputAdornment>
                  ),
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            name="note"
            control={control}
            render={({ field }) => (
              <TextField
                size="small"
                label="ملاحظات"
                fullWidth
                multiline
                rows={4}
                {...field}
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default JTransactionForm;
